<template>
  <div class="inspection-plan-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('inspectionPlanDetail.page.title')"
      :subtitle="$t('inspectionPlanDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 计划信息面板 -->
    <div class="ds-panel ds-panel--detail" v-loading="loading">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('inspectionPlanDetail.title') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.planName') }}</div>
              <div class="ds-field__value">{{ inspectionPlanDetailInfo.inspectionPlanName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.planRoute') }}</div>
              <div class="ds-field__value">{{ inspectionPlanDetailInfo.inspectionRouteName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.planPeriod') }}</div>
              <div class="ds-field__value">{{ inspectionPlanDetailInfo.inspectionPlanPeriodName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.signType') }}</div>
              <div class="ds-field__value">{{ inspectionPlanDetailInfo.signTypeName || '-' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.dateRange') }}</div>
              <div class="ds-field__value ds-num">
                {{ inspectionPlanDetailInfo.startDate || '-' }} ~ {{ inspectionPlanDetailInfo.endDate || '-' }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.timeRange') }}</div>
              <div class="ds-field__value ds-num">
                {{ inspectionPlanDetailInfo.startTime || '-' }} ~ {{ inspectionPlanDetailInfo.endTime || '-' }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.beforeTime') }}</div>
              <div class="ds-field__value ds-num">{{ inspectionPlanDetailInfo.beforeTime || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.creator') }}</div>
              <div class="ds-field__value">{{ inspectionPlanDetailInfo.createUserName || '-' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.createTime') }}</div>
              <div class="ds-field__value ds-num">{{ formatDateTimeSec(inspectionPlanDetailInfo.createTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('inspectionPlanDetail.status') }}</div>
              <div class="ds-field__value">
                <ds-status-tag :type="resolveState" :label="inspectionPlanDetailInfo.stateName || '-'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 标签页面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="inspectionPlanDetailInfo._currentTab"
        @tab-click="changeTab(inspectionPlanDetailInfo._currentTab)">
        <el-tab-pane :label="$t('inspectionPlanDetail.staff')" name="inspectionPlanDetailStaff">
          <inspection-plan-detail-staff ref="inspectionPlanDetailStaff" />
        </el-tab-pane>
        <el-tab-pane :label="$t('inspectionPlanDetail.route')" name="pointRoute">
          <point-route ref="pointRoute" />
        </el-tab-pane>
        <el-tab-pane :label="$t('inspectionPlanDetail.point')" name="inspectionRoutePoint">
          <inspection-route-point ref="inspectionRoutePoint" />
        </el-tab-pane>
        <el-tab-pane :label="$t('inspectionPlanDetail.task')" name="routeTask">
          <route-task ref="routeTask" />
        </el-tab-pane>
        <el-tab-pane :label="$t('inspectionPlanDetail.detail')" name="pointTaskDetail">
          <point-task-detail ref="pointTaskDetail" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import InspectionPlanDetailStaff from '@/components/inspection/InspectionPlanDetailStaff'
import PointRoute from '@/components/inspection/pointRoute'
import InspectionRoutePoint from '@/components/inspection/InspectionRoutePoint'
import RouteTask from '@/components/inspection/RouteTask'
import PointTaskDetail from '@/components/inspection/pointTaskDetail'
import { getInspectionPlanDetail } from '@/api/inspection/inspectionPlanDetailApi'
import { formatDateTimeSec } from '@/utils/format'
import { resolveStatus } from '@/utils/statusMap'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'InspectionPlanDetailList',
  components: {
    InspectionPlanDetailStaff,
    PointRoute,
    InspectionRoutePoint,
    RouteTask,
    PointTaskDetail,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      inspectionPlanDetailInfo: {
        beforeTime: '',
        canReexamine: '',
        createTime: '',
        createUserId: '',
        createUserName: '',
        endDate: '',
        endTime: '',
        inspectionDay: '',
        inspectionMonth: '',
        inspectionPlanId: '',
        inspectionPlanName: '',
        inspectionPlanPeriod: '',
        inspectionPlanPeriodName: '',
        inspectionRouteId: '',
        inspectionRouteName: '',
        inspectionWorkday: '',
        remark: '',
        signType: '',
        signTypeName: '',
        startDate: '',
        startTime: '',
        state: '',
        stateName: '',
        total: 0,
        records: 1,
        moreCondition: false,
        inspectionName: '',
        pointObjTypes: [],
        _currentTab: 'inspectionPlanDetailStaff'
      },
      communityId: ''
    }
  },
  computed: {
    /**
     * 巡检计划状态语义标签（inspection_plan 域）
     */
    resolveState() {
      const resolved = resolveStatus(this.inspectionPlanDetailInfo.state, {
        domain: 'inspectionPlan',
        text: this.inspectionPlanDetailInfo.stateName || '',
        fallbackLabel: this.inspectionPlanDetailInfo.stateName || ''
      })
      return resolved.type
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.inspectionPlanDetailInfo.inspectionPlanId = this.$route.query.inspectionPlanId
    this.getInspectionPlanDetail()
  },
  methods: {
    async getInspectionPlanDetail() {
      try {
        this.loading = true
        const params = {
          page: 1,
          row: 1,
          communityId: this.communityId,
          inspectionPlanId: this.inspectionPlanDetailInfo.inspectionPlanId
        }
        const { data } = await getInspectionPlanDetail(params)
        Object.assign(this.inspectionPlanDetailInfo, data[0])
        this.changeTab(this.inspectionPlanDetailInfo._currentTab)
      } catch (error) {
        console.error('获取巡检计划详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    changeTab(tab) {
      this.inspectionPlanDetailInfo._currentTab = tab
      setTimeout(() => {
        const componentRef = this.$refs[`${tab}`]
        if (componentRef && componentRef.open) {
          componentRef.open({
            inspectionPlanId: this.inspectionPlanDetailInfo.inspectionPlanId,
            inspectionRouteId: this.inspectionPlanDetailInfo.inspectionRouteId
          })
        }
      }, 500)
    },
    formatDateTimeSec(value) {
      return formatDateTimeSec(value)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ path: '/pages/property/inspectionPlan' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inspection-plan-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-spacing-sm);
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    background: var(--ds-gray-100);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 详情字段 */
.ds-field {
  margin-bottom: var(--ds-spacing-md);

  &__label {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
    margin-bottom: var(--ds-spacing-xs);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-800);
    line-height: 1.6;
    word-break: break-all;
  }
}
</style>
